'use strict';
var Backbone = require('backbone');
var pollHandler;

module.exports = Backbone.Model.extend({
    defaults: {
        'initialDuration': 0,
        'daysRemaining': 0,
        'hoursRemaining': 0,
        'minutesRemaining': 0,
        'secondsRemaining': 0,
        'totalSecondsRemaining': 0
    },

    countdownDuration: 0,
    countdownStartTime: 0,
    serverTime: 0,

    initialize: function(attrs, options) {
        this.options = options;
    },

    stop: function() {
        stopPolling();
    },

    reset: function () {
        this.clear({silent: true});
        this.set(this.defaults);
    },

    start: function(options) {
        options = options || this.options;
        if(!this.countdownDuration && !options.countdownDuration) {
            throw new Error('Counter model requires a countdownDuration value in seconds greater than zero.');
        }

        if(!this.countdownStartTime && !options.countdownStartTime) {
            throw new Error('Counter model requires a countdownStartTime value in seconds greater than zero.');
        }

        this.reset();
        this.countdownDuration = options.countdownDuration || this.countdownDuration || 0;
        this.countdownStartTime = options.countdownStartTime || this.countdownStartTime || 0;
        this.serverTime = options.serverTime || this.serverTime;
        this.localStartTime = Math.round(Date.now() / 1000);

        this.set('initialDuration', this.countdownDuration);

        startPolling.call(this);
    }
});

function stopPolling() {
    clearTimeout(pollHandler);
}

function startPolling() {
    stopPolling();
    tick.call(this);
}

function tick() {
    var currentLocalTime = Math.round(Date.now() / 1000);
    var elapsedTime = this.serverTime - this.countdownStartTime + (currentLocalTime - this.localStartTime);
    var remainingTime = this.countdownDuration - elapsedTime;

    if(remainingTime < 0) remainingTime = 0;

    var converted = convertSeconds(remainingTime);

    this.set({
        'daysRemaining': converted.day,
        'hoursRemaining': converted.hour,
        'minutesRemaining': converted.minute,
        'secondsRemaining': converted.seconds,
        'totalSecondsRemaining': remainingTime
    });

    if(remainingTime > 0) {
        pollHandler = setTimeout(tick.bind(this), 1000);
    }
}

function convertSeconds( seconds ) {

    var day;
    var hour;
    var minute;

    minute = Math.floor(seconds / 60);
    seconds = seconds % 60;
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    day = Math.floor(hour / 24);
    hour = hour % 24;
    return {
        day: day,
        hour: hour,
        minute: minute,
        seconds: seconds
    };
}



// WEBPACK FOOTER //
// ./app/scripts/models/countdown.js